// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { icon } from '../../tokens/themeColors/icon';
import { text } from '../../tokens/themeColors/text';
export var menuColors = function(mode) {
    var bg = background(mode);
    var ic = icon(mode);
    var tx = text(mode);
    return {
        background: bg.template.dialogs,
        icon: ic.heavy,
        subtext: tx.secondary,
        text: tx.primary,
        active: {
            background: bg.state.selectedTransparent,
            icon: ic.active,
            text: tx.primary
        },
        activeHover: {
            background: bg.state.selectedTransparent2
        },
        disabled: {
            icon: ic.disabled,
            text: tx.disabled
        },
        hover: {
            background: bg.state.hover0
        }
    };
};

//# sourceMappingURL=menuColors.js.map